// novem atom — dil seçici.
//
// Ürün beş yüzeyde tam Türkçe çeviri taşıyordu ama kullanıcının dilini
// seçebileceği HİÇBİR kontrol yoktu (tek istisna website footer'ıydı ve o da
// seçimi saklamıyordu). Keycloak giriş sayfasında Türkçe seçmek yalnızca o
// sayfayı çeviriyor, uygulamayı değil.
//
// Seçenekler SUPPORTED_LOCALES + LOCALE_METADATA'dan TÜRETİLİR, elle
// listelenmez: i18n-sdk'nın açık tasarım hedefi "yeni dil = locales.ts'te tek
// kayıt". Elle liste o hedefi ilk eklenen dilde bozardı.
//
// Sunum ViewToggle'a devredilir — aynı segmented-control görünümü ve aynı
// erişilebilirlik modeli (role="group" + aria-pressed). Kendi işaretlememizi
// yazmak iki ayrı klavye modeli doğururdu.
//
// Bilinçli olarak i18n'e BAĞLI DEĞİL: değeri ve etiketi çağıran verir. Bu
// paket react-i18next'e bağımlı değil ve kiosk gibi provider'sız yüzeyler de
// var; bileşeni sunumsal tutmak her ikisini de çözer.

import { forwardRef } from "react";

import { LOCALE_METADATA, SUPPORTED_LOCALES, type LocaleCode } from "@novemai/i18n-sdk";

import { ViewToggle } from "../ViewToggle/ViewToggle.tsx";

export interface LanguageSwitcherProps {
  /** Şu an etkin dil — seçili görünen düğme. */
  readonly value: LocaleCode;
  readonly onChange: (locale: LocaleCode) => void;
  /** Grubun erişilebilir adı (çevrilmiş) — görünür bir başlık yok. */
  readonly "aria-label": string;
  /** Localized action name containing the supplied native language name. */
  readonly getOptionLabel: (languageName: string) => string;
  readonly className?: string;
}

/** "tr-TR" → "TR". Düğme dar; tam ad aria-label'da taşınır. */
function shortCode(locale: LocaleCode): string {
  return (locale.split("-")[0] ?? locale).toUpperCase();
}

const OPTIONS = SUPPORTED_LOCALES.map((locale) => ({
  value: locale,
  icon: <span aria-hidden="true">{shortCode(locale)}</span>,
  // Dilin KENDİ adı (LOCALE_METADATA.name: "Türkçe" / "English (US)") —
  // dil seçicide etiketi arayüz diline çevirmek, aradığı dili tanımayan
  // kullanıcıyı tam da bu kontrolde kaybettirir.
  languageName: LOCALE_METADATA[locale].name,
}));

export const LanguageSwitcher = forwardRef<HTMLDivElement, LanguageSwitcherProps>(
  function LanguageSwitcher({ value, onChange, "aria-label": ariaLabel, getOptionLabel, className }, ref) {
    return (
      <ViewToggle<LocaleCode>
        ref={ref}
        options={OPTIONS.map(({ languageName, ...option }) => ({
          ...option,
          label: getOptionLabel(languageName),
        }))}
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
        {...(className !== undefined ? { className } : {})}
      />
    );
  },
);
